// import axios from "axios";
// import React, { useState, useEffect } from "react";
// import { Link, useHistory, useLocation, useParams } from "react-router-dom";
// import Swal from "sweetalert2";
// import Rightcontainer from "../Components/Rightcontainer";
// import "../css/layout.css";
// import "../css/login.css";
// import findGif from "../css/loading_old.gif";
// import Spinner from "react-bootstrap/Spinner";
// import { apiRequest } from '../../apiService/allApi'

// export default function Login() {
//   const history = useHistory();
//   // BASE URL

//   const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   const nodeMode = process.env.NODE_ENV;
//   if (nodeMode === "development") {

//     var baseUrl = beckendLocalApiUrl;
//   } else {
//     baseUrl = beckendLiveApiUrl;
//   }
//   // +++++++++++++++++++++++++++++

//   const { referralcode } = useParams();

//   const [Phone, setPhone] = useState();
//   const [twofactor_code, settwofactor_code] = useState();
//   const [otp, setOtp] = useState(false);
//   const [isLoading1, setIsloading1] = useState(false);
//   const [secretCode, setSecretCode] = useState();

//   let refs = useLocation().pathname.split("/")[2];
//   const [referral, setReferral] = useState(refs);

//   const handleClick = async (e) => {
//     e.preventDefault();
//     if (!Phone) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please enter your phone number",
//       });
//     } else if (Phone.length != 10) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please  enter currect phone number",
//       });
//     } else {
//       setIsloading1(true)

//       const respone = await apiRequest('login', "POST", { Phone, referral, })
//       // .then((respone) => {
//       setIsloading1(false)
//       if (respone?.data?.status == 101) {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: respone?.data?.msg,
//         });
//       } else if (respone?.data?.status == 200) {
//         setOtp(true);
//         setSecretCode(respone?.data?.secret);
//         if (respone?.data?.myToken) {
//           Swal.fire({
//             icon: "success",
//             title: "OTP",
//             text: "Demo Account Testing OTP: " + respone?.data?.myToken,
//           });
//         }
//       }
//       // })
//       // .catch((e) => {
//       //   Swal.fire({
//       //     icon: "error",
//       //     title: "Oops...",
//       //     text: "Something went wrong",
//       //   });
//       // });
//     }
//   };

//   const varifyOtp = async (e) => {
//     e.preventDefault();
//     if (!Phone) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please enter your phone number",
//       });
//       return;
//     }
//     setIsloading1(true);
//     try {
//       const response = await apiRequest(`login/finish`, "POST", { Phone, twofactor_code, referral, secretCode })

//       setIsloading1(false);

//       if (response?.data?.status === 101) {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: response?.data?.msg,
//         });
//       } else if (response?.data?.status === 200) {
//         const token = response?.data?.token;
//         localStorage.setItem("token", token);
//         // Reload the page and redirect after a delay
//         setTimeout(() => {
//           window.location.reload(true);
//           history.push("/Games"); // Assuming you have 'history' available
//         }, 1000);
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Something went wrong!",
//         });
//       }
//     } catch (error) {
//       setIsloading1(false);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Something went wrong!",
//       });
//     }
//   };

//   // otp valid
//   const [isValid, setIsValid] = useState(false);
//   const [showResend, setShowResend] = useState(false);
//   const [seconds, setSeconds] = useState(60);

//   useEffect(() => {
//     let timerInterval;

//     if (isValid && seconds > 0) {
//       timerInterval = setInterval(() => {
//         setSeconds((prevSeconds) => prevSeconds - 1);
//       }, 1000);
//     } else {
//       clearInterval(timerInterval);
//       setShowResend(true); // Show the Resend button when OTP expires
//       setIsValid(false);
//     }

//     return () => {
//       clearInterval(timerInterval);
//     };
//   }, [isValid, seconds]);

//   const handleResendClick = (e) => {
//     handleClick(e);
//     setIsValid(true);
//     setSeconds(60);
//     setShowResend(false); // Hide the Resend button after clicking it
//   };
//   return (
//     <>
//       <div className="login-screen-v4 leftContainer">

//         {/* 1. TOP HEADER SECTION (Branding/Welcome) */}
//         <div className="header-panel">
//           <h1 className="header-title text-gradend">Welcome Back!</h1>
//           <p className="header-subtitle">Log in, gear up, and dominate the game!</p>
//         </div>

//         {/* 2. FORM ACTION PANEL */}
//         <div className="form-panel">

//           <div className="form-card-v4">
//             <h2 className="form-heading">Login to your Account</h2>

//             {/* MOBILE NUMBER INPUT FIELD */}
//             <div className="input-group-v4">
//               <label className="input-label-v4" htmlFor="mobileNumber">Enter Phone Number</label>
//               <div className="input-field-wrapper">
//                 <span className="input-prefix">+91</span>
//                 <input
//                   id="mobileNumber"
//                   className="input-control"
//                   name="mobile"
//                   type="tel"
//                   placeholder="Mobile number"
//                   // **ORIGINAL LOGIC PRESERVED**
//                   onChange={(e) => {
//                     setPhone(e.target.value);
//                     if (e.target.value.length > 10) {
//                       // setError(true)
//                     }
//                   }}
//                 />
//               </div>
//             </div>

//             {/* OTP INPUT AND TIMER SECTION (CONDITIONAL VISIBILITY) */}
//             {otp && (
//               <div className="otp-container-v4">

//                 {/* OTP INPUT FIELD */}
//                 <div className="input-group-v4">
//                   <label className="input-label-v4" htmlFor="otpCode">Enter OTP</label>
//                   <div className="input-field-wrapper">
//                     <span className="input-prefix">#</span>
//                     <input
//                       id="otpCode"
//                       className="input-control"
//                       name="password"
//                       type="tel"
//                       placeholder="Enter OTP"
//                       // **ORIGINAL LOGIC PRESERVED**
//                       onChange={(e) => settwofactor_code(e.target.value)}
//                     />
//                   </div>
//                 </div>

//                 {/* RESEND TIMER / RESEND BUTTON */}
//                 <div className="timer-resend-area">
//                   {/* **ORIGINAL LOGIC PRESERVED** */}
//                   {isValid ? (
//                     <p className="timer-text valid-timer">
//                       OTP is valid for **{seconds} seconds**.
//                     </p>
//                   ) : seconds === 0 ? (
//                     <div className="timer-text expired-timer">
//                       {showResend && (
//                         <button className="resend-button-link" onClick={handleResendClick}>
//                           Resend OTP
//                         </button>
//                       )}
//                     </div>
//                   ) : (
//                     <p className="timer-text valid-timer">
//                       OTP is valid for **{seconds} seconds**.
//                     </p>
//                   )}
//                 </div>
//               </div>
//             )}

//             {/* BUTTON AREA */}
//             <div className="button-footer-v4">

//               {/* --- SEND OTP BUTTON LOGIC --- */}
//               {!otp && (
//                 isLoading1 ? (
//                   <button className="main-action-button loading-v4" disabled>
//                     <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
//                     Loading...
//                   </button>
//                 ) : (
//                   <button
//                     className="main-action-button primary-v4"
//                     // **ORIGINAL LOGIC PRESERVED**
//                     onClick={(e) => {
//                       handleClick(e);
//                       setIsValid(true);
//                     }}
//                   >
//                     Send OTP
//                   </button>
//                 )
//               )}

//               {/* --- VERIFY BUTTON LOGIC --- */}
//               {otp && (
//                 isLoading1 ? (
//                   <button className="main-action-button loading-v4" disabled>
//                     <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
//                     Loading...
//                   </button>
//                 ) : (
//                   <button
//                     className="main-action-button secondary-v4"
//                     // **ORIGINAL LOGIC PRESERVED**
//                     onClick={(e) => varifyOtp(e)}
//                   >
//                     Verify
//                   </button>
//                 )
//               )}
//             </div>

//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

import React, { useState, useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import { apiRequest } from "../../apiService/allApi";
// import "../css/loginNew.css";

export default function Login() {
  const history = useHistory();

  // BASE URL logic (preserved exactly)
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const nodeMode = process.env.NODE_ENV;
  let baseUrl =
    nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

  const { referralcode } = useParams();

  const [Phone, setPhone] = useState();
  const [twofactor_code, settwofactor_code] = useState();
  const [otp, setOtp] = useState(false);
  const [isLoading1, setIsloading1] = useState(false);
  const [secretCode, setSecretCode] = useState();

  let refs = useLocation().pathname.split("/")[2];
  const [referral, setReferral] = useState(refs);

  const handleClick = async (e) => {
    e.preventDefault();
    if (!Phone) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter your phone number",
      });
    } else if (Phone.length != 10) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter correct phone number",
      });
    } else {
      setIsloading1(true);
      const respone = await apiRequest("login", "POST", { Phone, referral });
      setIsloading1(false);
      if (respone?.data?.status == 101) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: respone?.data?.msg,
        });
      } else if (respone?.data?.status == 200) {
        setOtp(true);
        setSecretCode(respone?.data?.secret);
        if (respone?.data?.myToken) {
          Swal.fire({
            icon: "success",
            title: "OTP",
            text: "Demo Account Testing OTP: " + respone?.data?.myToken,
          });
        }
      }
    }
  };

  const varifyOtp = async (e) => {
    e.preventDefault();
    if (!Phone) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter your phone number",
      });
      return;
    }
    setIsloading1(true);
    try {
      const response = await apiRequest(`login/finish`, "POST", {
        Phone,
        twofactor_code,
        referral,
        secretCode,
      });
      setIsloading1(false);

      if (response?.data?.status === 101) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response?.data?.msg,
        });
      } else if (response?.data?.status === 200) {
        const token = response?.data?.token;
        localStorage.setItem("token", token);
        setTimeout(() => {
          window.location.reload(true);
          history.push("/Games");
        }, 1000);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    } catch (error) {
      setIsloading1(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };

  // OTP valid timer logic
  const [isValid, setIsvalid] = useState(false);
  const [showResend, setShowResend] = useState(false);
  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    let timerInterval;
    if (isValid && seconds > 0) {
      timerInterval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
    } else {
      clearInterval(timerInterval);
      setShowResend(true);
      setIsvalid(false);
    }
    return () => {
      clearInterval(timerInterval);
    };
  }, [isValid, seconds]);

  const handleResendClick = (e) => {
    handleClick(e);
    setIsvalid(true);
    setSeconds(60);
    setShowResend(false);
  };

  return (
    <div className="max-page-container">
      {/* 3. MAIN LOGIN BODY CONTAINER */}
      <div className="max-login-wrapper">
        <div className="max-login-card">
          {/* LOGO AREA */}
          <div className="max-logo-container">
            <img
              src="/joker.png"
              alt="JOKERLUDO"
              style={{
                width: "120px",
                height: "auto",
                objectFit: "contain",
                display: "block",
              }}
            />
          </div>

          {/* SIGN IN TITLE */}
          <h1 className="max-signin-title">SIGN IN</h1>

          {/* MOBILE NUMBER INPUT */}
          <div className="max-input-group">
            <span className="max-prefix">+91</span>
            <input
              className="max-input-field"
              type="tel"
              placeholder="Mobile Number"
              maxLength={10}
              onChange={(e) => {
                setPhone(e.target.value);
              }}
            />
          </div>

          {/* OTP INPUT SECTION (Conditional) */}
          {otp && (
            <div className="max-otp-section">
              <div className="max-input-group">
                <span className="max-prefix">#</span>
                <input
                  className="max-input-field"
                  type="tel"
                  placeholder="Enter OTP"
                  onChange={(e) => settwofactor_code(e.target.value)}
                />
              </div>

              <div className="max-timer-area">
                {isValid ? (
                  <p className="max-timer-text">
                    OTP is valid for <b>{seconds}</b> seconds.
                  </p>
                ) : seconds === 0 ? (
                  <div>
                    {showResend && (
                      <button
                        className="max-resend-link"
                        onClick={handleResendClick}
                      >
                        Resend OTP
                      </button>
                    )}
                  </div>
                ) : (
                  <p className="max-timer-text">
                    OTP is valid for <b>{seconds}</b> seconds.
                  </p>
                )}
              </div>
            </div>
          )}

          {/* ACTION BUTTONS */}
          <div className="max-button-container">
            {!otp &&
              (isLoading1 ? (
                <button className="max-submit-btn" disabled>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Loading...
                </button>
              ) : (
                <button
                  className="max-submit-btn"
                  onClick={(e) => {
                    handleClick(e);
                    setIsvalid(true);
                  }}
                >
                  Get OTP
                </button>
              ))}

            {otp &&
              (isLoading1 ? (
                <button className="max-submit-btn" disabled>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Loading...
                </button>
              ) : (
                <button
                  className="max-submit-btn"
                  onClick={(e) => varifyOtp(e)}
                >
                  Verify
                </button>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}
